import { render, staticRenderFns } from "./emailSignature.vue?vue&type=template&id=63497cba&"
import script from "./emailSignature.vue?vue&type=script&lang=js&"
export * from "./emailSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports